let CommonActionTypeValue = /*#__PURE__*/function (CommonActionTypeValue) {
  CommonActionTypeValue["Back"] = "Back";
  CommonActionTypeValue["Cancel"] = "Cancel";
  CommonActionTypeValue["Close"] = "Close";
  CommonActionTypeValue["Select"] = "Select";
  CommonActionTypeValue["Loading"] = "Loading";
  CommonActionTypeValue["Edit"] = "Edit";
  CommonActionTypeValue["Done"] = "Done";
  return CommonActionTypeValue;
}({});

export { CommonActionTypeValue };
